module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-up--.321ab2c0.svg";